<template>
    <div class="dayDeal">
        <div class="dayDeal-sum">
            <div class="dayDeal-row">
                <img :src="imgUrl.line" class="dayDeal-img" />
                <span class="dayDeal-num">183</span>
            </div>
            <div class="dayDeal-text">日成交量</div>
        </div>
        <div class="dayDeal-line"></div>
        <div class="dayDeal-money">
            <div class="dayDeal-row">
                <img :src="imgUrl.line" class="dayDeal-img" />
                <span class="dayDeal-num">21574</span>
            </div>
            <div class="dayDeal-text">日成交额</div>
        </div>
    </div>
</template>

<script>
    import logo from '../assets/logo.png';
    
    export default {
        data() {
            return {
                imgUrl: {
                    line: logo,
                }
            }
        },
        methods: {
    
        }
    }
</script>

<style lang="scss" scoped>
    @import '../style/mixin';
    @import '../style/_variables';
    .dayDeal {
        height: 100%;
        background-color: $totel-bg;
        color: $totel-font-color;
        @include flex-row;
        >.dayDeal-sum {
            flex: 2;
            @include flex-column;
            font-size: $totel-font-size;
        }
        >.dayDeal-line {
            flex: 1;
            width: 8vw;
            height: 8vw;
            border-top: 2px solid #fff;
            transform: rotate(45deg);
            transform-origin: 0 0;
        }
        >.dayDeal-money {
            flex: 2;
            @include flex-column;
            font-size: $totel-font-size;
        }
        .dayDeal-img {
            width: $totel-img-width;
            height: $totel-img-height;
        }
        .dayDeal-num {
            font-size: $totel-num-size;
        }
        .dayDeal-row {
            @include flex-row;
        }
        .dayDeal-text {
            margin-top: 20px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/DayDeal.vue